import type { GetState, NamedSet } from '@core/zustand'

import type { Channel } from '../types'

import type { State } from './state'

export type Actions = ReturnType<typeof createActions>

/**
 * Channels actions
 */
export function createActions(set: NamedSet<State>, get: GetState<State>) {
  return {
    /** Store whether the business owning a channel is active. */
    setBusinessActive: (identifier: string, businessActive: boolean) =>
      set(
        (state) => ({
          businessActiveByIdentifier: {
            ...state.businessActiveByIdentifier,
            [identifier]: businessActive,
          },
        }),
        false,
        'setBusinessActive',
      ),
    /** Update channel in global store */
    updateChannel: (channel: Channel) =>
      set(
        (state) => ({
          byId: {
            ...state.byId,
            [channel.encoded_id]: channel,
          },
        }),
        false,
        'updateChannel',
      ),
    /** Mark channel fetch request as requested so that we don't make the same request again */
    markRequested: (key: string): boolean => {
      if (get().requested[key]) {
        return true
      }
      set(
        (state) => ({ requested: { ...state.requested, [key]: true } }),
        false,
        'markRequested',
      )
      return false
    },
    clearRequested: () =>
      set(
        { businessActiveByIdentifier: {}, requested: {} },
        false,
        'clearRequested',
      ),
  }
}
